(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sultan-campaign-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('sultan-campaign-popup')) return;
    class SultanCampaignPopup extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.start = Number(this.dataset.start) * 1000;
        this.end = Number(this.dataset.end) * 1000;
        this.key = 'sultan-promo-seen:' + this.dataset.start + ':' + this.dataset.end;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.querySelectorAll('[data-promo-close]').forEach(button => {
          button.addEventListener('click', () => this.dialog.close(), options);
        });
        this.dialog.addEventListener('click', event => {
          if (event.target === this.dialog) this.dialog.close();
        }, options);
        document.addEventListener('visibilitychange', () => this.refresh(), options);
        window.addEventListener('pageshow', () => this.refresh(), options);
        this.timer = setTimeout(() => this.refresh(), 700);
      }
      seen() {
        try { return sessionStorage.getItem(this.key) === '1'; }
        catch { return true; }
      }
      refresh() {
        clearTimeout(this.timer);
        const now = Date.now();
        if (!Number.isFinite(this.start) || !Number.isFinite(this.end) || this.end <= this.start || now >= this.end) {
          if (this.dialog.open) this.dialog.close();
          return;
        }
        if (now < this.start) {
          this.timer = setTimeout(() => this.refresh(), Math.min(this.start - now + 50, 60000));
          return;
        }
        if (!this.shown && !this.seen() && !document.hidden && !document.querySelector('dialog[open]')) {
          this.dialog.showModal();
          this.shown = true;
          try { sessionStorage.setItem(this.key, '1'); } catch {}
        }
        this.timer = setTimeout(() => this.refresh(), Math.min(this.end - now + 50, 60000));
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.events?.abort();
        this.initialized = false;
      }
    }
    customElements.define('sultan-campaign-popup', SultanCampaignPopup);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sultan-campaign"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('sultan-campaign')) return;
    class SultanCampaign extends HTMLElement {
      connectedCallback() { this.refresh(); }
      refresh() {
        const now = Date.now();
        const start = Date.parse(this.dataset.start);
        const end = Date.parse(this.dataset.end);
        this.hidden = !Number.isFinite(start) || !Number.isFinite(end) || now < start || now >= end;
        const phase = now < start ? 'upcoming' : 'active';
        this.dataset.phase = phase;
        this.querySelectorAll('[data-campaign-state]').forEach(element => {
          element.hidden = element.dataset.campaignState !== phase;
        });
      }
    }
    customElements.define('sultan-campaign', SultanCampaign);
    let timer;
    const refreshAll = () => {
      clearTimeout(timer);
      let next = 60000;
      const now = Date.now();
      document.querySelectorAll('sultan-campaign').forEach(element => {
        element.refresh();
        [element.dataset.start, element.dataset.end].forEach(value => {
          const remaining = Date.parse(value) - now;
          if (remaining > 0) next = Math.min(next, remaining + 50);
        });
      });
      timer = setTimeout(refreshAll, next);
    };
    refreshAll();
    window.addEventListener('pageshow', refreshAll);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshAll(); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sultan-whatsapp"] && !Shopify.designMode) return;
  try {
    (() => {
  const widget = document.getElementById('sultan-whatsapp');
  if (!widget) return;
  const away = widget.querySelector('[data-wa-away]');
  const formatter = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
  const update = () => {
    const parts = Object.fromEntries(formatter.formatToParts(new Date()).map(p => [p.type, p.value]));
    const minutes = Number(parts.hour) * 60 + Number(parts.minute);
    away.hidden = parts.weekday !== 'Sun' && minutes >= 600 && minutes < 1140;
  };
  update();
  setInterval(update, 15000);
  document.addEventListener('visibilitychange', update);
  widget.addEventListener('toggle', update);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && widget.open) {
      widget.open = false;
      widget.querySelector('summary').focus();
    }
  });
  document.addEventListener('click', event => {
    if (widget.open && !widget.contains(event.target)) widget.open = false;
  });
})();
  } catch(e) { console.error(e); }
})();

})();
